import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import StyledLoanPrograms from "./styles";
import axios from "axios";
import { BrowserRouter as Router, Route, Routes, useParams, useLocation, Navigate, Link } from 'react-router-dom';
import { getProductLink } from "../../utils";

export default function LoanPrograms({ brokerData, handleScrollRef }) {
  const mloID = brokerData?.loID || "";
  const { brokerUrl } = useParams();

  let loanProductsList = [
    // "ANGEL AI FLYERS",
    // "ANGEL AI POSTS",
    "CONVENTIONAL LOANS",
    "DOWN PAYMENT ASSISTANCE",
    "FHA LOANS",
    "HELOC",
    // "INVESTMENT PROPERTIES",
    "JUMBO LOANS",
    "NON-QM",
    "REFINANCING",
    "RENOVATION AND CONSTRUCTION LOANS",
    "REVERSE MORTGAGE",
    "USDA RURAL HOUSING LOAN PROGRAM",
    "VA LOANS",
    "OTHERS",
  ];

  if (["4RSM", "4CK7", "4CL8", "4FG2", "8LG1", "8SEA", "8JGW"].includes(mloID)) {
    loanProductsList = [
      ...loanProductsList.filter((product) => product !== "OTHERS"), // Exclude "OTHERS"
      "CO-MARKETING",
      "INDUSTRY NEWS",
      "CLOSE IN XXX DAYS",
      "OTHERS", // Add "OTHERS" at the end
    ];
  } else {
    loanProductsList = [
      ...loanProductsList.filter((product) => product !== "OTHERS"), // Exclude "OTHERS"
      "OTHERS", // Add "OTHERS" at the end
    ];
  }

  const [productLoadArray, setProductLoadArray] = useState(
    Array(loanProductsList.length).fill(false)
  );

  const [showOthers, setShowOthers] = useState(false);
  const [othersProductList, setOthersProductList] = useState(null);
  const [othersLoadArray, setOthersLoadArray] = useState([]);

  useEffect(() => {
    const getOthersCategories = async () => {
      if (!othersProductList && mloID) {
        try {
          const { data } = await axios.get(
            getProductLink(`/loan_officers/${mloID}/LoanServicesData.json`)
          );

          if (data) {
            let othersArray = [];
            data.forEach((flyerObj) => {
              const flyerCategory = flyerObj.category_path.toLowerCase();
              const nonASCIITest = /^[\x20-\x7E]+$/.test(flyerObj.pdf_path);
              if (
                flyerCategory.toLowerCase().includes("others") &&
                nonASCIITest
              ) {
                othersArray.push(flyerCategory);
              }
            });
            othersArray = [...new Set(othersArray)];
            setOthersProductList(othersArray);
            setOthersLoadArray(Array(othersArray.length).fill(false));
            // if (filteredData) setFlyerData(filteredData);
          }
        } catch (err) {
          console.log(err);
        }
      }
    };
    getOthersCategories();
  }, [mloID, othersProductList]);

  const handleOthersClick = () => {
    setShowOthers(true);
    const sectionTop = document.getElementById("loan-products");
    sectionTop.scrollIntoView({
      behavior: "instant",
      block: "start",
      inline: "nearest",
    });
  };
  const handleBackClick = () => {
    setShowOthers(false);
  };
  const onImageLoad = (i, setFunction) => {
    setFunction((prev) => {
      const prevCopy = [...prev];
      prevCopy[i] = true;
      return prevCopy;
    });
  };

  const loadLoanServices = () => {
    return loanProductsList.map((product, i) => {
      const productImageName = product.replace(/,/g, "").replaceAll(" ", "_").toLowerCase();
      const productLinkName = product.replace(/,/g, "").replaceAll(" ", "-").toLowerCase();
      const angelAiProduct = product.toLowerCase().includes("angel");
      const productImageLink = getProductLink(
        `/images/broker_category_icons/${productImageName}/icon.jpg`
      );
      const displayName = product.replace("ANGEL AI", "ANGELAI");
      //conditional classes

      const colSize = angelAiProduct ? "big" : "";
      const othersShown = showOthers ? "hide-product" : "";
      return (
        <Col
          key={product}
          md={6}
          lg={angelAiProduct ? 6 : 4}
          className={`product-col  ${colSize} ${othersShown}`}
          id="loan-product-new"
        >
          <Link
            onClick={(e) => {
              handleScrollRef(e.target.getBoundingClientRect());
              if (product === "OTHERS") handleOthersClick(product);
            }}
            to={product !== "OTHERS" ? `/${brokerUrl}/${productLinkName}` : "#"}
          >
            <div
              className={`loan-product-box ${
                productLoadArray[i] ? "show" : "hidden"
              }`}
            >
              <div className="loan-product-filter"></div>

              <Image
                alt={`${productImageName} Product Flyers`}
                onLoad={() => onImageLoad(i, setProductLoadArray)}
                className="loan-product-image"
                fluid
                src={productImageLink}
              />

              <h2 className="loan-product-name">{displayName}</h2>
            </div>
          </Link>
        </Col>
      );
    });
  };

  const loadOthersServices = () => {
    return othersProductList?.map((product, i) => {
      const productImageName = product.replaceAll(" ", "_").toLowerCase();
      const productLinkName = product.replaceAll(" ", "-").toLowerCase();

      const productImageLink = getProductLink(
        `/images/lo_category_icons/${productImageName}icon.jpg`
      );
      const otherProductName = product.split("/")[1].toUpperCase();

      return (
        <Col
          key={product}
          md={4}
          className={`product-col ${showOthers ? "" : "hide-product"}`}
        >
          <Link to={`/${brokerUrl}/${productLinkName}`}>
            <div
              className={`loan-product-box less-filter ${
                othersLoadArray[i] ? "show" : "hidden"
              }`}
            >
              <div className="loan-product-filter"></div>
              <Image
                alt={`${productImageName} Product Flyers`}
                className="loan-product-image"
                fluid
                onLoad={() => onImageLoad(i, setOthersLoadArray)}
                src={productImageLink}
              />
              <h2 className="loan-product-name">{otherProductName}</h2>
            </div>
          </Link>
        </Col>
      );
    });
  };

  return (
    <StyledLoanPrograms id="loan-products">
      <h1 className="loan-product-title">Loan Services</h1>
      <Container className="d-flex flex-column-reverse justify-content-start align-items-center flex-md-column position-relative">
        {showOthers && (
          <div
            role="button"
            aria-label="Back"
            onClick={handleBackClick}
            className="back-button"
          />
        )}
        <Row className={`main-loanprograms-row ${showOthers ? "hide-main-loanprograms-row" : "show-main-loanprograms-row"}`}>{loadLoanServices()}</Row>
        <Row className={`others-row ${showOthers ? "show" : "hide-others"}`}>
          {loadOthersServices()}
        </Row>
      </Container>
    </StyledLoanPrograms>
  );
}
